import { TSortOption } from '@features/webBooking/types';

export enum BOOKING_TYPE {
  AIRLINE_TICKETS = 'airline-tickets',
  HOTEL = 'hotel',
  AMUSEMENT_PARK = 'amusement-park',
  INSURANCE = 'insurance',
  VISA = 'visa',
  COMBO = 'combo',
  TOUR = 'tour',
}

export const BookingPageTitle = {
  [BOOKING_TYPE.AIRLINE_TICKETS]: 'vé máy bay',
  [BOOKING_TYPE.HOTEL]: 'khách sạn',
  [BOOKING_TYPE.AMUSEMENT_PARK]: 'vé vui chơi',
  [BOOKING_TYPE.INSURANCE]: 'bảo hiểm',
  [BOOKING_TYPE.TOUR]: 'tour',
} as const;

export type BookingPageTitleKeys = keyof typeof BookingPageTitle;

export enum AIR_TICKET_BOOKING_STATUS {
  RESERVED = 'reserved',
  ISSUED = 'issued',
  FAILED = 'failed',
}

export enum AIR_TICKET_BOOKING_TYPE {
  ONE_WAY = 'ONE_WAY',
  ROUND_TRIP = 'ROUND_TRIP',
}

export enum SORT_BY {
  PRICE = 'PRICE',
  START_DATE = 'START_DATE',
}

export enum SORT_TYPE {
  ASCENDING = 'ASCENDING',
  DESCENDING = 'DESCENDING',
}

export enum ITINERARY {
  DEPARTURE,
  RETURN,
}

export const sortOptions: TSortOption[] = [
  {
    value: SORT_BY.PRICE,
    label: 'Vé rẻ nhất',
    define: {
      sortBy: SORT_BY.PRICE,
      sortType: SORT_TYPE.ASCENDING,
    },
  },
  {
    value: SORT_BY.START_DATE,
    label: 'Giờ bay sớm nhất',
    define: {
      sortBy: SORT_BY.START_DATE,
      sortType: SORT_TYPE.ASCENDING,
    },
  },
];

export enum RULE_TYPE {
  NOTE = 'NOTE',
  INFO = 'INFO',
  HAND_BAGGAGE = 'HAND_BAGGAGE',
  CHECKED_BAGGAGE = 'CHECKED_BAGGAGE',
  REFUND = 'REFUND',
  CHANGE = 'CHANGE',
  NO_SHOW = 'NO_SHOW',
  GO_SHOW = 'GO_SHOW',
}

export const CalendarNavWeekDayDifferences = [-3, -2, -1, 0, 1, 2, 3];
export const CalendarNavWeekMobile = [-1, 0, 1];

export enum ALERT_TYPE {
  ERROR = 'ERROR',
  INFO = 'INFO',
  SUCCESS = 'SUCCESS',
  WARNING = 'WARNING',
}

export const PassengerType = {
  adult: 'ADT',
  children: 'CHD',
  infant: 'INF',
} as const;

export enum GET_BOOKING_TYPE {
  AIRLINE = 'AIRLINE',
  TICKET = 'TICKET',
  HOTEL = 'HOTEL',
  INSURANCE = 'INSURANCE',
  TOUR = 'TOUR',
}

export const GetBookingTypeTitle = {
  [GET_BOOKING_TYPE.AIRLINE]: 'Vé máy bay',
  [GET_BOOKING_TYPE.TICKET]: 'Vé vui chơi',
  [GET_BOOKING_TYPE.HOTEL]: 'Khách sạn',
  [GET_BOOKING_TYPE.INSURANCE]: 'Bảo hiểm',
  [GET_BOOKING_TYPE.TOUR]: 'Tour du lịch',
};

export enum FLIGHT_SESSION {
  DEPARTURE = 'departureFlightSession',
  RETURN = 'returnFlightSession',
}

export enum OCCUPANCY_TYPE {
  ADULT,
  CHILDREN,
}

export enum FARE_FAMILY {
  ECONOMY_SUPER_LITE = 'Siêu Tiết kiệm',
  ECONOMY_LITE = 'Phổ thông tiết kiệm',
  ECONOMY_CLASSIC = 'Phổ thông tiêu chuẩn',
  PREMIUM_ECONOMY = 'Phổ thông đặc biệt',
  ECONOMY_FLEX = 'Phổ thông linh hoạt',
  BUSINESS = 'Thương gia',
  ECONOMY = 'Tiết kiệm',
  PREMIUM = 'Phổ thông',
}

export const ITINERARY_TYPE_OPTIONS = [
  {
    label: 'Khứ hồi',
    value: AIR_TICKET_BOOKING_TYPE.ROUND_TRIP,
  },
  {
    label: 'Một chiều',
    value: AIR_TICKET_BOOKING_TYPE.ONE_WAY,
  },
];

export enum FORM_FIELD {
  AIRLINE_CODE = 'airlineCode',
  STOP_CODE = 'stopCode',
  FARE_FAMILY = 'fareFamily',
}

export const FormLabel: Record<FORM_FIELD, string> = {
  [FORM_FIELD.AIRLINE_CODE]: 'Hãng bay',
  [FORM_FIELD.STOP_CODE]: 'Điểm dừng',
  [FORM_FIELD.FARE_FAMILY]: 'Hạng vé',
};

export enum PASSENGER_RESPONSE_TYPE {
  ADT = 'ADT',
  CHD = 'CHD',
  INF = 'INF',
}

export const PassengerResponseTypeTitle = {
  [PASSENGER_RESPONSE_TYPE.ADT]: 'Người lớn',
  [PASSENGER_RESPONSE_TYPE.CHD]: 'Trẻ em',
  [PASSENGER_RESPONSE_TYPE.INF]: 'Em bé',
};
